










import { Vue, Component } from 'vue-property-decorator';
import PromptBar from '@lib-shared/prompt-bar/PromptBar.vue';
@Component({
  components: {
    PromptBar,
  },
})
export default class DownloadingPromptBar extends Vue {}
